import { getOldAppClientId } from "@/config/runtimeConfig";

export const M365_CONNECTIONS_CLIENT_ID =
  "26502742-8245-4188-a050-bdce56ecaa9b";

const normaliseClientId = (value: unknown): string =>
  String(value ?? "").toLowerCase();

// A connection is on the legacy Azure app when it reports no client_id, the
// hardcoded legacy connections id, or the configured old-app id. The match is
// case-insensitive because Graph may return differently-cased GUIDs; keeping
// this in one place stops the MSP table and the customer page from disagreeing.
export const isLegacyClientId = (clientId: unknown): boolean => {
  const normalised = normaliseClientId(clientId);
  return (
    !normalised ||
    normalised === normaliseClientId(getOldAppClientId()) ||
    normalised === normaliseClientId(M365_CONNECTIONS_CLIENT_ID)
  );
};
